import { render, staticRenderFns } from "./linkResource.vue?vue&type=template&id=718e344c&"
import script from "./linkResource.vue?vue&type=script&lang=js&"
export * from "./linkResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports